const CalendarIcon1 = () => {
   return (
      <svg
         xmlns="http://www.w3.org/2000/svg"
         width="43"
         height="43"
         viewBox="0 0 43 43"
         fill="none"
      >
         <path
            d="M7.80078 14.5498H35.8008M7.80078 14.5498V29.9501C7.80078 31.9103 7.80078 32.8899 8.18226 33.6386C8.51782 34.2972 9.05286 34.8331 9.71143 35.1687C10.4594 35.5498 11.439 35.5498 13.3954 35.5498H30.2062C32.1625 35.5498 33.1408 35.5498 33.8887 35.1687C34.5473 34.8331 35.0841 34.2972 35.4197 33.6386C35.8008 32.8906 35.8008 31.9124 35.8008 29.9561V14.5498M7.80078 14.5498V13.1501C7.80078 11.19 7.80078 10.2091 8.18226 9.46045C8.51782 8.80188 9.05286 8.26684 9.71143 7.93128C10.4601 7.5498 11.4409 7.5498 13.4011 7.5498H14.8008M35.8008 14.5498V13.1444C35.8008 11.188 35.8008 10.2084 35.4197 9.46045C35.0841 8.80188 34.5473 8.26684 33.8887 7.93128C33.14 7.5498 32.1613 7.5498 30.2011 7.5498H28.8008M28.8008 4.0498V7.5498M28.8008 7.5498H14.8008M14.8008 4.0498V7.5498"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
      </svg>
   )
}

export default CalendarIcon1
